import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextDrugFluvastatin } from "./TextDrugFluvastatin";


export default function Fluvastatin() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
  
    <ButtonsText onClick={handleOpen} name='Fluvastatin' size='large' color='common.white' />
    
    <CustomDialog open={open} onClose={handleClose}

        title="Fluvastatin - PGx Recommendation"
        content={ <TextDrugFluvastatin />}

        />

</>
)}